import React, {useState} from 'react'
import {addDays, formatDate, subDays} from '../../common/utils/dateUtils'
import {Box} from '../../webui/Box'
import {Container} from '../../webui/Container'
import {LoadingSpinnerContainer} from '../../webui/progress/LoadingSpinnerContainer'
import {useAllBoxesForSelect} from '../box/gql/useAllBoxesForSelect'
import {useAllOrganisations} from '../organisation/gql/useAllOrganisations'
import {useAllProducts} from '../product/gql/useAllProducts'
import {StatisticsRentalFilter} from './filter/StatisticsRentalFilter'
import {Filter} from './filter/types'
import {StatisticsRental} from './rentals/StatisticsRental'

interface Props {}

const initialFromDate = formatDate(subDays(new Date(), 1))
const initialEndDate = formatDate(addDays(new Date(), 1))

export const StatisticsRentalsPage: React.FC<Props> = () => {
  const {data: products, loading: productsLoading} = useAllProducts()

  // Lightweight list for dropdown options (id + name only).
  const {data: boxesForSelect, loading: boxesForSelectLoading} = useAllBoxesForSelect()

  const {data: allOrganisations, loading: allOrganisationsLoading} = useAllOrganisations()

  const [filter, setFilter] = useState<Filter>({
    selectedBoxes: [],
    fromDate: initialFromDate,
    selectedProducts: [],
    selectedGenders: [],
    onlyActiveBoxes: true,
    endDate: initialEndDate,
  })
  const [hasAppliedFilter, setHasAppliedFilter] = useState(false)

  const onFilterChange = (next: Filter) => {
    setFilter(next)
    setHasAppliedFilter(true)
  }

  if (boxesForSelectLoading || productsLoading || allOrganisationsLoading) {
    return <LoadingSpinnerContainer />
  }

  return (
    <Container>
      <StatisticsRentalFilter
        boxesForSelect={boxesForSelect}
        allProducts={products}
        allOrganisations={allOrganisations}
        initialFilter={filter}
        onFilterChange={onFilterChange}
      />
      <Box mt={2} />
      {hasAppliedFilter && <StatisticsRental filter={filter} />}
    </Container>
  )
}
